import React, {Component} from 'react';
import {withRouter} from "react-router-dom";
import classnames from 'classnames';
import './DepartmentUploads.scss';
import BreadrumbsNavigation from "./BreadrumbsNavigation";
import DepartmentFolderUploads from "./DepartmentFolderUploads";
import DepartmentFileUploads from "./DepartmentFileUploads";
import FileUploader from "../../../shared/forms/FIleUploader";
import {connect} from "react-redux";
import {ApiDelete, ApiGet, ApiPatch, ApiPost} from "../../../shared/services/api-service";
import departmentSettingsActionsCreators from '../../store/department-settings/action-creators/index';
import optionsActionCreators from "../../store/options/action-creators";
import notificationsActionsCreator from '../../store/notifications/action-creators';

class DepartmentUploads extends Component {
  constructor(props) {
    super(props);

    this.state = {
      uploadedDocuments: [],
      folderStack: [],
      isDropdownOpen: false,
      isCreateFolderOpen: false,
      isManageFilePermissionOpen: false,
      file: null,
      selectedFile: null,
      overFolderIndex: -1
    };
  }

  componentDidMount() {
    this.getUploadedDocuments(null);
    this.props.fetchOptions('roles');
    this.props.loadDepartmentSettings();
  }

  get rolesOptionsTranslated() {
    if (this.props.rolesOptions && this.props.settings) {
      const rolesFiltered = this.props.rolesOptions.filter(role => role.scope !== 'depadmin');

      return rolesFiltered.reduce((acc, role) => {
        const roleName = this.props.settings.rolesSettings && this.props.settings.rolesSettings[role.scope];
        return [
          ...acc,
          {
            ...role,
            name: roleName ? roleName : role.name
          }
        ];

      }, []);
    }
  }

  get roles() {
    return this.rolesOptionsTranslated.map(role => role.scope);
  }

  getUploadedDocuments(parentId) {
    let parentIdStr = '';
    if (parentId) {
      parentIdStr = '?parent_id=';
      parentIdStr += parentId;
    }

    return ApiGet('/api/v1/department-files' + parentIdStr)
      .then(uploadedDocuments => {
        this.setState({
          uploadedDocuments: uploadedDocuments.sort((folderA, folderB) => (folderA.order > folderB.order) ? 1 : -1)
        })

        return uploadedDocuments;
      })
  }

  uploadDocument(file) {
    this.setState({
      isManageFilePermissionOpen: true,
      file: file
    })
  }

  saveFile(selectedRoles) {
    let fileObj = {
      name: this.state.file.s3Key,
      type: "FILE"
    }

    if (selectedRoles !== null && selectedRoles.length !== this.roles.length) {
      fileObj.roles = selectedRoles;
    }

    ApiPost('/api/v1/department-files', {
      department_file: {
        file: fileObj,
        parent_id: this.state.folderStack.length > 0 ? this.state.folderStack[this.state.folderStack.length - 1].id : null
      }
    }).then(uploadedFile => {
      this.setState({
        isManageFilePermissionOpen: false,
        isDropdownOpen: false,
        uploadedDocuments: [...this.state.uploadedDocuments, uploadedFile],
        file: null
      })
    })
  }

  editFile(updatedFile, file) {
    ApiPatch('/api/v1/department-files/' + file.id, {
      department_file: {
        file: updatedFile
      }
    }).then(uploadedFile => {
      this.getUploadedDocuments(file.parent_id);
    })
  }

  createFolder(folderName, selectedRoles) {
    let fileObj = {
      name: folderName,
      type: "FOLDER"
    }

    if (selectedRoles !== null && selectedRoles.length !== this.roles.length) {
      fileObj.roles = selectedRoles;
    }

    ApiPost('/api/v1/department-files', {
      department_file: {
        file: fileObj,
        parent_id: this.state.folderStack.length > 0 ? this.state.folderStack[this.state.folderStack.length - 1].id : null
      }
    }).then(uploadedFile => {
      this.setState({
        isCreateFolderOpen: false,
        isDropdownOpen: false,
        uploadedDocuments: [...this.state.uploadedDocuments, uploadedFile]
      })
    })
  }

  moveFolderToAnotherFolder(currentFolder, destinationFolder) {
    ApiPatch('/api/v1/department-files/' + currentFolder.id, {
      department_file: {
        ...currentFolder,
        parent_id: destinationFolder.id
      }
    }).then(uploadedFile => {
      this.getUploadedDocuments(currentFolder.parent_id);

      this.props.notifySuccess(`${currentFolder.file.type} has been moved successfully to folder`);
    })
    .catch(err => {
      this.props.notifyError(`Error occured during ${currentFolder.file.type} move`);
    })
  }

  deleteUploadedFile(deletedFile) {
    ApiDelete(`/api/v1/department-files/${deletedFile.id}`)
      .then(() => {
        this.setState({
          uploadedDocuments: this.state.uploadedDocuments.filter(file => file.id !== deletedFile.id)
        })
      })
  }

  dropdownClick() {
    this.setState({
      isDropdownOpen: !this.state.isDropdownOpen
    })
  }

  showCreateFolderModal() {
    this.setState({
      isCreateFolderOpen: true,
      folderName: '',
    })
  }

  folderClick(folder) {
    let folderStack = this.state.folderStack;
    if (!folderStack.find(f => f.id === folder.id)) {
      folderStack.push(folder);
      this.setState({
        folderStack
      });

      this.getUploadedDocuments(folder.id);
    }
  }

  goToFolder(folderId) {
    let folderStack = [];
    if (folderId) {
      folderStack = this.state.folderStack;

      const index = folderStack.indexOf(folderStack.find(folder => folder.id === folderId));
      folderStack.splice(index + 1);
    }

    this.setState({
      folderStack
    });

    this.getUploadedDocuments(folderId);
  }

  closeCreateFolderModal() {
    this.setState({
      isCreateFolderOpen: false,
    });
  }

  closeFilePermissionsModal() {
    this.setState({
      isManageFilePermissionOpen: false,
    });
  }

  reorderFiles(files) {
    let index = 0;
    const filesMapped = files.reduce((acc, file) => {
      return [
        ...acc,
        {
          id: file.id,
          order: index++
        }
      ];

    }, []);

    ApiPost('/api/v1/department-files/update_multiple', {
      files: filesMapped
    }).then(uploadedFile => {
      this.props.notifySuccess('Successful Reorder');
    })
    .catch(err => {
      const currentFolder = this.state.folderStack.length > 0 ? this.state.folderStack[this.state.folderStack.length - 1].id : null;
      this.getUploadedDocuments(currentFolder);

      this.props.notifyError('There has been an error');
    })
  }

  updateUploadedDocumentsList(nextPosEl, currPosEl) {
    if (nextPosEl && currPosEl) {
      const nextPosIndex = this.state.uploadedDocuments.indexOf(nextPosEl);
      const currPosIndex = this.state.uploadedDocuments.indexOf(currPosEl);

      let uploadedDocuments = [
        ...this.state.uploadedDocuments.slice(0, currPosIndex),
        ...this.state.uploadedDocuments.slice(currPosIndex + 1)
      ]

      uploadedDocuments.splice(nextPosIndex, 0, currPosEl);

      let index = 0;
      const uploadedDocumentsOrdered = uploadedDocuments.reduce((acc, file) => {
        return [
          ...acc,
          {
            ...file,
            order: index++
          }
        ];

      }, []);

      this.reorderFiles(uploadedDocumentsOrdered);

      this.setState({
        uploadedDocuments: uploadedDocumentsOrdered
      })
    }
  }

  fileDragStartEnd(selectedFile) {
    this.setState({
      selectedFile
    })
  }

  filterFolders() {
    let folders = this.state.uploadedDocuments.filter(obj => obj.file.type === 'FOLDER');

    return folders.filter(folder => {
      return !folder.file.roles
        || this.props.userContext.scope === 'depadmin'
        || (folder.file.roles && folder.file.roles.includes(this.props.userContext.scope));
    });
  }

  moveFileToFolder(folderIndex) {
    if (folderIndex !== null) {
      this.moveFolderToAnotherFolder(this.state.selectedFile, this.filterFolders()[folderIndex]);

      this.setState({
        overFolderIndex: -1
      })
    }
  }

  overFolder(folderIndex) {
    this.setState({
      overFolderIndex: folderIndex
    })
  }

  render() {
    return (
      <div>
        <div className="app-content-header">
          <h4 className="title">Department Uploads</h4>

          {this.props.userContext.hasScope('depadmin') &&
            <div className="upload-dropdown">
              <button className="drop-btn button secondary" onClick={() => this.dropdownClick()}>
                <i className="fa fa-plus" />
                New
              </button>
              <div className={classnames('dropdown-content', {
                'show': this.state.isDropdownOpen
              })}>
                <FileUploader
                  onUpload={file => this.uploadDocument(file)}
                  departmentGuid={this.props.userContext.departmentGuid}/>
                <a onClick={() => this.showCreateFolderModal()}>
                  Folder
                </a>
              </div>
            </div>
          }
        </div>

        <div className="app-content department-uploads">
          <BreadrumbsNavigation
            navigationMenu={this.state.folderStack}
            rootMenu="Home"
            onMenuClick={folder => this.goToFolder(folder)} />

          {this.rolesOptionsTranslated &&
            <DepartmentFolderUploads
              uploadedDocuments={this.state.uploadedDocuments}
              folderStack={this.state.folderStack}
              userContext={this.props.userContext}
              rolesOptionsTranslated={this.rolesOptionsTranslated}
              roles={this.roles}
              isCreateFolderOpen={this.state.isCreateFolderOpen}
              selectedFile={this.state.selectedFile}
              overFolderIndex={this.state.overFolderIndex}
              onCreateClick={(folder, selectedRoles) => this.createFolder(folder, selectedRoles)}
              onFolderOpenClick={(folder) => this.folderClick(folder)}
              onFolderEdit={folder => this.goToFolder(folder)}
              onDelete={folder => this.deleteUploadedFile(folder)}
              onCreateFolderModalClose={() => this.closeCreateFolderModal()}
              onUpdateUploadedDocumentsList={(nextPosEl, currPosEl) => this.updateUploadedDocumentsList(nextPosEl, currPosEl)}
              onMoveFolderToAnotherFolder={(currentFolder, destinationFolder) => this.moveFolderToAnotherFolder(currentFolder, destinationFolder)}
            />
          }

          {this.rolesOptionsTranslated &&
            <DepartmentFileUploads
              uploadedDocuments={this.state.uploadedDocuments}
              folderStack={this.state.folderStack}
              userContext={this.props.userContext}
              rolesOptionsTranslated={this.rolesOptionsTranslated}
              roles={this.roles}
              isManageFilePermissionOpen={this.state.isManageFilePermissionOpen}
              onPermissionsModalClose={() => this.closeFilePermissionsModal()}
              onDeleteUploadedFile={(file) => this.deleteUploadedFile(file)}
              onUploadDocument={(file) => this.uploadDocument(file)}
              onCreateClick={(selectedRoles) => this.saveFile(selectedRoles)}
              onEditFilePermissions={(updatedFile, file) => this.editFile(updatedFile, file)}
              onUpdateUploadedDocumentsList={(nextPosEl, currPosEl) => this.updateUploadedDocumentsList(nextPosEl, currPosEl)}
              onFileDragStartEnd={(file) => this.fileDragStartEnd(file)}
              onMoveFileToFolder={(folderIndex) => this.moveFileToFolder(folderIndex)}
              onOverFolder={(folderIndex) => this.overFolder(folderIndex)}
            />
          }
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  userContext: state.common.userContext,
  rolesOptions: state.options.roles,
  settings: state.departmentSettings.settings
});

const mapDispatchToProps = (dispatch) => {
  return {
    fetchOptions: (apiKey) => {
      return dispatch(optionsActionCreators.fetchOptions(apiKey))
    },
    loadDepartmentSettings: () => {
      dispatch(departmentSettingsActionsCreators.loadDepartmentSettings());
    },
    notifyError: (message) => {
      dispatch(notificationsActionsCreator.addError(message))
    },
    notifySuccess: (message) => {
      dispatch(notificationsActionsCreator.addSavedSuccessfully(message))
    }
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DepartmentUploads));
